import React from 'react';

export default function Footer() {
  return (
    <footer className="app-footer">
      <p>© Clementine ABA — HIPAA Compliance Training Portal · Powered by Odyssey Solutions</p>
    </footer>
  );
}
